import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu', 'arrow']

  toggle() {
    this.menuTarget.classList.toggle('hidden')
    this.arrowTarget.classList.toggle('rotate-180')
  }
}
